"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_native_1 = require("react-native");
var styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        zIndex: 2,
    },
    disabled: {
        opacity: 0.5,
    },
    segment: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    segmentText: {
        fontSize: 13,
        paddingLeft: 2,
        paddingRight: 2,
        width: '100%',
        textAlign: 'center',
    },
    segmentActiveText: {
        fontWeight: 'bold',
    },
});
exports.default = styles;
//# sourceMappingURL=SegmentStyles.js.map